import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=4825be6d&scoped=true"
import script from "./Policy.vue?vue&type=script&lang=js"
export * from "./Policy.vue?vue&type=script&lang=js"
import style0 from "./_policy.css?vue&type=style&index=0&id=4825be6d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4825be6d",
  null
  
)

export default component.exports